import * as React from 'react';
import { ApiTypes } from '@wix/social-groups-api/dist/src/types';
import {
  Block,
  BlockFlow,
  GroupTypeSelect,
  GroupTypeSelectOption,
  ImageLoader,
  SwitchBlock,
} from '@wix/social-groups-common';
import { Input } from 'wix-ui-tpa/Input';
import { Text } from 'wix-ui-tpa/Text';
import styles from './GroupSettings.st.css';
import { InjectedTranslateProps, translate } from 'react-i18next';

interface DetailsSettingsProps {
  title: string;
  privacyLevel: ApiTypes.v1.GroupPrivacyLevel;
  logoUrl: string;

  onPrivacyChange(privacyLevel: ApiTypes.v1.GroupPrivacyLevel);

  onLogoUpload(image: File);

  onTitleChange(title: string);

  onDisplaySwitch();
  imageUploading?: boolean;
}

export const SOCIAL_GROUP_NAME_MAX_LENGTH = 50;

const translationKeys = {
  [ApiTypes.v1.GroupPrivacyLevel.PUBLIC]: {
    value: 'groups-web.types.public.name',
    subtitle: 'groups-web.types.public.description',
  },
  [ApiTypes.v1.GroupPrivacyLevel.PRIVATE]: {
    value: 'groups-web.types.private.name',
    subtitle: 'groups-web.types.private.description',
  },
  [ApiTypes.v1.GroupPrivacyLevel.SECRET]: {
    value: 'groups-web.types.secret.name',
    subtitle: 'groups-web.types.secret.description',
  },
};

interface DetailsSettingsComponentProps
  extends DetailsSettingsProps,
    InjectedTranslateProps {}

export const DetailsSettingsComponent: React.FunctionComponent<DetailsSettingsComponentProps> = (
  props: DetailsSettingsComponentProps,
) => {
  const {
    t,
    title,
    privacyLevel,
    logoUrl,
    onPrivacyChange,
    onLogoUpload,
    onDisplaySwitch,
    onTitleChange,
  } = props;

  const groupNameLabel = t('groups-web.settings.name');
  const groupTypeLabel = t('groups-web.settings.type');
  const displayLabel = t('groups-web.settings.image');

  const onChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    onTitleChange(e.target.value);
  };

  const onSelect = (selectedOption: GroupTypeSelectOption) => {
    onPrivacyChange(selectedOption.id as ApiTypes.v1.GroupPrivacyLevel);
  };
  //TODO: render Display Cover Image switcher
  const renderSwitchBlock = () => (
    <SwitchBlock onChange={onDisplaySwitch}>
      <Text>{displayLabel}</Text>
    </SwitchBlock>
  );

  return (
    <>
      <Block flow={BlockFlow.row}>
        <Text tagName={'label'} {...styles(styles.labelText)}>
          {groupNameLabel}
        </Text>
        <Input
          maxLength={SOCIAL_GROUP_NAME_MAX_LENGTH}
          onChange={onChange}
          value={title}
        />
      </Block>
      <Block flow={BlockFlow.row}>
        <Text tagName={'label'} {...styles(styles.labelText)}>
          {groupTypeLabel}
        </Text>
        <GroupTypeSelect
          translationKeys={translationKeys}
          onSelect={onSelect}
          selectedType={privacyLevel}
        />
      </Block>
      <ImageLoader imageUrl={logoUrl} uploadImage={onLogoUpload} />
    </>
  );
};

export const DetailsSettings = translate()(
  DetailsSettingsComponent,
) as React.ComponentType<DetailsSettingsProps>;
DetailsSettings.displayName = 'DetailsSettings';
